import React, { useState } from "react";
import SingleStaffList from "./partials/singleStaffList";
import SingleStaffGrid from "./partials/singleStaffGrid";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import { Staff as STAFF_QUERY } from "../../queries/staff.query";
import { useQuery } from "@apollo/react-hooks";
import auth from "../../providers/Auth.Provider";
import LoadingSpinner from "../../partials/loading";
import Pagination from "../../partials/pagination";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";
import FabButton from "../../partials/Buttons/FabButton";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET } from "../../event/model";

const StaffList = ({ history }) => {
    const [showGrid, SetShowGrid] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(25);

    const title = "Staff Management";

    //Get authenticated user's authentication info
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();

    // Fetch list of staff record
    const { loading, data, fetchMore, refetch } = useQuery(STAFF_QUERY.QUERY.GETSTAFFLIST, {
        variables: {
            site: site && site.id,
            page,
            limit,
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    EventEmitter.subscribe(EVENT_TARGET.STAFF, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-md-12 mb-4">
                    {/* List and Grid view toggle */}
                    <ul className="nav">
                        <li className="nav-item">
                            <button
                                type="submit"
                                onClick={() => {
                                    SetShowGrid(false);
                                }}
                                className={`mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle ${showGrid ? "" : "btn-success"}`}
                            >
                                <i className="material-icons">view_list</i>
                                List View
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                type="button"
                                onClick={() => {
                                    SetShowGrid(true);
                                }}
                                className={`mdl-button mdl-button--raised mdl-js-ripple-effect ml-2 btn-circle ${showGrid ? "btn-success" : ""}`}
                            >
                                <i className="material-icons">view_module</i>
                                Grid View
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            {/* List */}
            {!showGrid && (
                <div className="row fade-in">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-head">
                                <div className="tools">
                                    <a className="fa fa-repeat btn-color box-refresh" href="javascript:;"></a>
                                </div>
                            </div>
                            <div className="card-body" style={{ minHeight: "440px" }}>
                                <LoadingSpinner loading={loading} />
                                {data && <SingleStaffList staff={data.GetStaffList.docs} />}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Grid */}
            {showGrid && <>{data && <SingleStaffGrid items={data.GetStaffList.docs} />}</>}
            {data && data.GetStaffList.docs.length && (
                <div className="row fade-in">
                    <div className="col-md-12">
                        <div className="card">
                            <Pagination
                                length={data.GetStaffList.docs.length}
                                {...data.GetStaffList}
                                onPageClicked={(page) => {
                                    setPage(page);
                                    fetchMore({
                                        variables: { page },
                                        updateQuery: (prev, { fetchMoreResult }) => {
                                            if (!fetchMoreResult) return prev;
                                            return {
                                                GetStaffList: fetchMoreResult.GetStaffList,
                                            };
                                        },
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
            <FabButton
                title="New Staff"
                onClick={() => {
                    history.push("/home/staffing/new");
                }}
            />
        </>
    );
};

export default StaffList;
